import { cn } from "@/lib/cn";

interface SegmentOption {
  value: string;
  label: string;
}

interface SegmentedProps {
  options: (SegmentOption | string)[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/** 세그먼트 컨트롤 — 라디오 그룹 형태의 선택 UI */
const Segmented = ({ options, value, onChange, className }: SegmentedProps) => (
  <div
    className={cn("inline-flex h-8 rounded-lg bg-slate-100 p-0.5", className)}
    role="radiogroup"
  >
    {options.map((o) => {
      const optValue = typeof o === "string" ? o : o.value;
      const optLabel = typeof o === "string" ? o : o.label;
      const isActive = value === optValue;

      return (
        <button
          key={optValue}
          type="button"
          role="radio"
          aria-checked={isActive}
          className={cn(
            "relative rounded-md px-3 py-1 text-[13.5px] leading-snug transition-all",
            isActive
              ? "bg-white font-semibold text-slate-900 shadow-sm"
              : "font-medium text-gray-500 hover:text-foreground",
          )}
          onClick={() => onChange(optValue)}
        >
          {optLabel}
        </button>
      );
    })}
  </div>
);

export { Segmented };
export type { SegmentedProps, SegmentOption };
